const currentYear = new Date().getFullYear();

module.exports = {
  footerText: "Copyright Perfit Rocks © "+ currentYear,
};
